// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1bFqN","messages":"Chat_messages__2lBZQ","dateDivider":"Chat_dateDivider__1eDXV"};